import { IMG_URL } from "../../constant";
import {
  Card,
  Cards,
  Content,
  CoverTitleImg,
  Title,
  WrapCards,
  WrapContent,
  WrapSelect,
  WrapTitle,
} from "../style/styled";
import { CompSelectDistrict } from "./CompSelectDistrict";

export function PageSelectDistrict() {
  return (
    <WrapContent>
      <Content>
        <WrapCards>
          <Cards>
            <Card idx={1}>
              <img
                src={`${IMG_URL}/card_z.png`}
                alt="우리동네 대선이야기 카드 이미지"
              />
            </Card>
            <Card idx={2}>
              <img
                src={`${IMG_URL}/card_k.png`}
                alt="우리동네 대선이야기 카드 이미지"
              />
            </Card>
            <Card idx={3}>
              <img
                src={`${IMG_URL}/card_q.png`}
                alt="우리동네 대선이야기 카드 이미지"
              />
            </Card>
            <Card idx={4}>
              <img
                src={`${IMG_URL}/card_t.png`}
                alt="우리동네 대선이야기 카드 이미지"
              />
            </Card>

            <Card idx={5}>
              <img
                src={`${IMG_URL}/card_w.png`}
                alt="우리동네 대선이야기 카드 이미지"
              />
            </Card>
            <Card idx={6}>
              <img
                src={`${IMG_URL}/card_u.png`}
                alt="우리동네 대선이야기 카드 이미지"
              />
            </Card>
            <Card idx={7}>
              <img
                src={`${IMG_URL}/card_x.png`}
                alt="우리동네 대선이야기 카드 이미지"
              />
            </Card>
            <Card idx={8}>
              <img
                src={`${IMG_URL}/card_r.png`}
                alt="우리동네 대선이야기 카드 이미지"
              />
            </Card>
          </Cards>
        </WrapCards>
        <WrapSelect>
          <CoverTitleImg>
            <img
              src="https://s3.ap-northeast-2.amazonaws.com/mabu.newscloud.sbs.co.kr/election2022/images/pagetitle.png"
              alt="우리동네 대선이야기 타이틀 이미지"
            />
          </CoverTitleImg>

          <CompSelectDistrict />
        </WrapSelect>
      </Content>
    </WrapContent>
  );
}
